import { X } from 'lucide-react';
import CategoryForm from './CategoryForm';

export default function CategoryModal({ isOpen, onClose, onSubmit, parentCategories = [], allCategories = [], category, isSubmitting = false,apiError = null }) {
  const isEditMode = !!category;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[95vh] sm:max-h-[90vh] flex flex-col">
        <div className="p-4 sm:p-6 border-b flex justify-between items-center flex-shrink-0">
          <h2 className="text-lg sm:text-xl font-semibold">{isEditMode ? 'Edit Category' : 'Add New Category'}</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0 ml-2"
            aria-label="Close"
          >
            <X size={20} className="sm:w-6 sm:h-6" />
          </button>
        </div>
        <CategoryForm
          onSubmit={onSubmit}
          parentCategories={parentCategories}
          allCategories={allCategories}
          category={category}
          isSubmitting={isSubmitting}
          onCancel={onClose}
          apiError={apiError} 
        />
      </div>
    </div>
  );
}
